'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, document, next_tick, list_keys, path_root, foreach_key, get_nice_publication_type_name,
    map, extend, echo, range, downloadify_create, base_href, mustache, group, groupToMap, display_when_ready,
} = pubdb;
const { open, Morris } = window;


const COUNT = 0;
const YEAR = 1;
const TYPE = 2;
const IMPACT_FACTOR = 3;

const PUB_TYPE_INDEX = {
    '*': 0,
    'wissenschaftlicher_beitrag': 1,
    'buchautorenschaft': 2,
    'buchbeitrag': 3,
    'buchherausgeberschaft': 3,
    'e_veroeffentlichung': 4,
    'hochschulschrift': 5,
    'patentschrift': 6,
    'poster': 7,
    'rezension': 8,
    'rundfunk_fernseh_beitrag': 9,
    'vortrag': 10,
    'zeitschriftenherausgeberschaft': 11
};
const PUB_TYPE_NAME = list_keys(PUB_TYPE_INDEX);


let we_stats;
let NO_CLICK = 0;

const year_max = new Date().getUTCFullYear();
const year_min = year_max - 9;

const WE_NAMES = map(range(1, 21), i => `WE ${i < 10 ? 0 : ''}${i}`);
const WE_COLORS = [
    '#1abc9c', '#2ecc71', '#3498db', '#9b59b6',
    '#34495e', '#16a085', '#27ae60', '#2980b9',
    '#2980b9', '#8e44ad', '#2c3e50', '#f1c40f',
    '#e67e22', '#e74c3c', '#95a5a6', '#f39c12',
    '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d',
];


function add_download_csv (dest, title, data) {
    const download_container = $('<div/>', {
        css: {
            position: 'absolute',
            right: '-1px',
            top: '-1px',
            'border': '1px solid #aaa',
            background: '#ccc'
        },
        'class': 'noprint',
        appendTo: dest,
    }).hide();

    dest.hover(function () {
        download_container.show();
        download_container.appendTo(dest);
    }, function () {
        download_container.detach();
        download_container.hide();
    });

    downloadify_create(
        $('<div/>', {
            appendTo: download_container,
            style: 'margin: 4px',
            title: 'Rohdaten als CSV exportieren',
            click (ev) {
                ev.stopPropagation();
            },
        })[0],
        {
            downloadImage: base_href + '/static/icons/tango/0.8.90/22x22/mimetypes/x-office-spreadsheet.png',
            title: false,
            filename () {
                return title.replace(/\s+/g, '_') + '.csv';
            },
            data,
            onError () {
                echo('Konnte Rohdaten nicht exportieren');
            },
            height: 22,
            width: 22,
        },
    );

    downloadify_create(
        $('<div/>', {
            appendTo: download_container,
            style: 'margin: 4px',
            title: 'Bild als SVG exportieren',
            click (ev) {
                ev.stopPropagation();
            },
        })[0],
        {
            downloadImage: base_href + '/static/icons/tango/0.8.90/22x22/mimetypes/x-office-presentation.png',
            title: false,
            filename () {
                return title.replace(/\s+/g, '_') + '.svg';
            },
            data () {
                return $('svg', dest)[0].outerHTML;
            },
            onError () {
                echo('Konnte SVG nicht exportieren');
            },
            height: 22,
            width: 22,
        },
    );
}


function add_graph (dest, title, opts) {
    $('<h3/>', {
        text: title + ':',
        css: { 'margin-top': '2em', },
        appendTo: dest,
    });

    const dest_div = $('<div/>', {
        css: {
            height: '540px',
            width: '1200px',
            border: '1px solid #aaa',
        },
        appendTo: dest,
    });
    dest_div.hover(function () {
        $(this).css('background-color', '#f0f0f0');
    }, function () {
        $(this).css('background-color', '');
    });
    const options = {
        element: dest_div,
        ymin: 0,
        ymax: 'auto',
        parseTime: false,
        hideHover: 'auto',
        smooth: false,
        _type: 'Bar',
        stacked: true,
        xLabelAngle: 60,
    };
    const status = {
        redraw,
        dest_div,
        graph: null
    };

    function redraw (further_options) {
        const new_options = {};
        extend(new_options, options, further_options);
        dest_div.empty();
        status.graph = Morris[new_options['_type']](new_options);
    }

    redraw(opts);
    return status;
}


function display_we_stats (pubs, dest) {
    function pubtypes_per_year (pubs, types) {
        var ykeys = [];
        var labels = [];
        foreach_key(types, function (key) {
            ykeys.push(key);
            if (key === '*') {
                labels.push('Gesamt');
            } else {
                labels.push(get_nice_publication_type_name(key, false));
            }
        });

        var years = {};
        pubs.forEach(function (row) {
            var count = row[COUNT];
            var year = row[YEAR];
            var type = PUB_TYPE_NAME[row[TYPE]];

            var year_datum = years[year] = (years[year] || { '*': 0 });
            year_datum['*'] += count;
            year_datum[type] = (year_datum[type] || 0) + count;
        });

        var year_max = new Date().getUTCFullYear();
        var year_min = year_max - 9;
        var global_max = 0;
        var data = [];
        for (var year = year_min; year <= year_max; ++year) {
            var year_datum = years[year];
            var datum = { year: year };
            if (year_datum) {
                var local_accu = 0;
                foreach_key(types, function (key) {
                    var value = year_datum[key] || 0;
                    local_accu += value;
                    datum[key] = value;
                });
                if (global_max < local_accu) {
                    global_max = local_accu;
                }
            }
            data.push(datum);
        }

        var result = {
            ykeys: ykeys,
            xkey: 'year',
            labels: labels,
            data: data,
            ymax: Math.ceil(global_max / 4) * 4,
        };
        return result;
    }

    function add_pubs_per_year_graph () {
        var inputs = [];
        var types = { wissenschaftlicher_beitrag: true };
        function add_input (type) {
            if (type === '*') {
                return;
            }
            var input = $('<input/>', {
                type: 'checkbox',
                on: {
                    change: function () {
                        if ($(this).is(':checked')) {
                            types[type] = true;
                        } else {
                            delete types[type];
                            if ($.isEmptyObject(types)) {
                                if (NO_CLICK++) {
                                    echo('warn', 'Sie können nicht das letzte Element abwählen.');
                                    echo('confirm', 'Wählen Sie zuerst ein anderes Element dazu.');
                                }
                                types[type] = true;
                                $(this).attr('checked', true);
                                return;
                            }
                        }
                        next_tick(function () {
                            redraw(pubtypes_per_year(pubs, types));
                        });
                    }
                },
                attr: {
                    checked: types[type]
                }
            });
            var name = type === '*' ? 'Gesamt' : {
                wissenschaftlicher_beitrag: 'Wissenschaftliche Beiträge',
                zeitschriftenherausgeberschaft: 'Zeitschriftenherausgeberschaften'
            }[type] || get_nice_publication_type_name(type, false);
            var label = $('<label/>', {
                append: [ input, document.createTextNode('\xA0' + name) ],
                style: 'margin: 0 0.5ex; white-space: nowrap; display: block;',
            });
            inputs.push(label, ' ');
        }
        foreach_key(PUB_TYPE_INDEX, add_input);

        var title = (
            'Veröffentlichungen ' +
            (we_stats ? 'der wissenschaftlichen Einrichtung' : 'am Fachbereich') +
            ' pro Jahr'
        );

        const { redraw, dest_div } = add_graph(dest, title, pubtypes_per_year(pubs, types));

        function gen_csv_data () {
            const { labels, ykeys, data } = pubtypes_per_year(pubs, PUB_TYPE_INDEX);
            return mustache((
                '\uFEFF' +
                '"Jahr"' + labels.map(k => `\t"${k}"`).join('') + '\r\n' +
                '{{#data}}' +
                    '"{{year}}"' + ykeys.map(k => `\t"{{${k}}}"`).join('') + '\r\n' +
                '{{/data}}'
            ), { data });
        }

        add_download_csv(dest_div, title, gen_csv_data);

        $('<div/>', {
            style: 'text-align: center; padding-top: 1rem',
            append: $('<div/>', {
                append: inputs,
                'class': 'inline-checkbox noprint',
                style: (
                    '-moz-column-count: 3; ' +
                    '-webkit-column-count: 3; ' +
                    '-ms-column-count: 3; ' +
                    '-o-column-count: 3; ' +
                    'column-count: 3; ' +
                    'display: inline-block; ' +
                    'text-align: left'
                ),
            }),
            appendTo: dest,
        });
    }

    function add_if_per_year_graph (aggregate) {
        const data = [];
        let ymax = 0;
        for (let year = year_min; year <= year_max; ++year) {
            var amount = (years[year] || {})[aggregate] || 0;
            if (amount > ymax) {
                ymax = amount;
            }
            data.push({
                year: year,
                amount: (amount|0) === amount ? amount : amount.toFixed(3),
            });
        }

        switch (aggregate) {
            case 'count':
                var title0 = 'Anzahl der wissenschaftlichen Beiträge mit Impact Factor';
                break;
            case 'sum':
                var title0 = 'Kumulierter Impact Factor';
                break;
            case 'avg':
                var title0 = 'Durchschnittlicher Impact Factor';
                break;
        }
        var title = title0 + (we_stats ? 'der wissenschaftlichen Einrichtung' : 'am Fachbereich') + ' pro Jahr';

        var { dest_div } = add_graph(dest, title, {
            data: data,
            xkey: 'year',
            ykeys: ['amount'],
            labels: [title0],
            ymax: Math.ceil(ymax / 4) * 4,
        });

        add_download_csv(dest_div, 'WE ' + (100 + we_stats.we.id).toString().substr(1) + ' - ' + title, () => mustache((
            '\uFEFF' +
            '"Jahr"\t"' + title0 + '"\r\n' +
            '{{#data}}' +
                '"{{year}}"\t"{{amount}}"\r\n' +
            '{{/data}}'
        ), { data }));
    }

    function add_quartiles_bar (title) {
        let ymax = 0;
        const data = [];
        let has_unknown_quartiles = 0;
        for (let year = year_min; year <= year_max; ++year) {
            const [q1, q2, q3, q4, qq] = (years[year] || {}).quartiles || [0, 0, 0, 0, 0];
            ymax = Math.max(ymax, q1 + q2 + q3 + q4 + qq);
            data.push({ q1, q2, q3, q4, qq, year });
            has_unknown_quartiles += qq;
        }

        const { dest_div } = add_graph(dest, title, {
            data,
            xkey: 'year',
            ykeys: ['q1', 'q2', 'q3', 'q4'],
            labels: ['1. Quartil', '2. Quartil', '3. Quartil', '4. Quartil'],
            ymax: Math.ceil(ymax / 4) * 4,
            barColors: (row, series, type) => ['#99CC00', '#669922', '#336644', '#003366', '#666666'][series.index],
        });

        add_download_csv(dest_div, 'WE ' + (100 + we_stats.we.id).toString().substr(1) + ' - ' + title, () => mustache((
            '\uFEFF' +
            '"Jahr"\t"Q1"\t"Q2"\t"Q3"\t"Q4"\t"Q?"\r\n' +
            '{{#data}}' +
                '"{{year}}"\t"{{q1}}"\t"{{q2}}"\t"{{q3}}"\t"{{q4}}"\t"{{qq}}"\r\n' +
            '{{/data}}'
        ), { data }));
    }

    var years = {};
    pubs.forEach(function (row) {
        const [count, year, type, impact_factor, quartile] = row;
        if (impact_factor && (impact_factor > 0) && (type === 1/*wissenschaftlicher_beitrag*/)) {
            const year_data = years[year] = (years[year] || { sum: 0, count: 0, quartiles: [0, 0, 0, 0, 0] });
            year_data.sum += count * impact_factor;
            year_data.count += count;
            if (quartile && quartile > 0) {
                year_data.quartiles[quartile - 1] += count;
            } else {
                year_data.quartiles[4] += count;
            }
        }
    });
    foreach_key(years, function (year) {
        const year_datum = years[year];
        year_datum.avg = year_datum.sum / year_datum.count;
    });

    we_stats = pubdb.we_stats;
    dest = $(dest || '#pubdb_data')
    if (!dest) {
        return;
    }

    add_pubs_per_year_graph();
    add_quartiles_bar('Anzahl der wissenschaftlichen Beiträge mit Impact Factor der wissenschaftlichen Einrichtung pro Jahr');
    add_if_per_year_graph('sum');
    add_if_per_year_graph('avg');

    dest.find('.throbber').detach();
}


function display_all_wes_stats (pubs, dest) {
    function add_bar (title, value_fun) {
        let ymax = 0;
        const data = [];
        for (var i = 0; i < 20; ++i) {
            var v = value_fun(i);
            if (v > ymax) {
                ymax = v;
            }
            data.push({
                we: WE_NAMES[i],
                count: (v|0) === v ? v : v.toFixed(3),
                we_id: i + 1
            });
        }

        const { dest_div } = add_graph(dest, title, {
            data,
            ymax: Math.ceil(ymax / 4) * 4,
            xkey: 'we',
            ykeys: ['count'],
            labels: [title],
            hoverCallback: (index, options, content) => (
                '<div class="morris-hover-row-label">' +
                we_stats.we_names[index] +
                ' (WE ' + (index > 8 ? index+1 : '0' + (index+1)) + ')' +
                '</div>' +
                '<div class="morris-hover-point" style="color:#000">' +
                options.labels[0] + ': ' + options.data[index].count +
                '</div>'
            ),
            barColors: function (row, series, type) {
                if (type === 'bar') {
                    return WE_COLORS[row.x];
                } else {
                    return '#000';
                }
            },
        });

        add_download_csv(dest_div, we_stats.year + ' - ' + title, () => mustache((
            '\uFEFF' +
            '"WE"\t"Wert"\r\n' +
            '{{#data}}' +
                '"{{we}}"\t"{{count}}"\r\n' +
            '{{/data}}'
        ), { data }));
    }

    function add_quartiles_bar (title) {
        let ymax = 0;
        const data = [];
        for (let i = 0; i < 20; ++i) {
            const [q1, q2, q3, q4, qq] = quartiles_by_we[i];
            ymax = Math.max(ymax, q1 + q2 + q3 + q4 + qq);
            data.push({
                we: WE_NAMES[i],
                q1, q2, q3, q4, qq,
                we_id: i + 1,
            });
        }

        const options = {
            data,
            ymax: Math.ceil(ymax / 4) * 4,
            xkey: 'we',
            ykeys: ['q1', 'q2', 'q3', 'q4'],
            labels: ['1. Quartil', '2. Quartil', '3. Quartil', '4. Quartil'],
            barColors: (row, series, type) => ['#99CC00', '#669922', '#336644', '#003366', '#666666'][series.index],
        }
        if (has_unknown_quartiles) {
            options.ykeys.push('qq');
            options.labels.push('?. Quartil');
        }
        var { dest_div } = add_graph(dest, title, options);

        add_download_csv(dest_div, we_stats.year + ' - ' + title, () => mustache((
            '\uFEFF' +
            '"WE"\t"Q1"\t"Q2"\t"Q3"\t"Q4"\t"Q?"\r\n' +
            '{{#data}}' +
                '"{{we}}"\t"{{q1}}"\t"{{q2}}"\t"{{q3}}"\t"{{q4}}"\t"{{qq}}"\r\n' +
            '{{/data}}'
        ), { data }));
    }

    function add_totals_bar (title) {
        let ymax = 0;
        const data = [];
        for (let i = 0; i < 20; ++i) {
            ymax = Math.max(ymax, count_by_we[i]);
            data.push({
                we: WE_NAMES[i],
                count: count_by_we[i],
                no_if: count_by_we[i] - has_if_by_we[i],
                has_if: has_if_by_we[i],
                we_id: i + 1,
            });
        }

        const { dest_div } = add_graph(dest, title, {
            data,
            xkey: 'we',
            ykeys: ['has_if', 'no_if'],
            labels: ['Mit Impact Factor', 'Ohne Impact Factor'],
            barColors: (row, series, type) => series.index ? '#003366' : '#99CC00',
            ymax: Math.ceil(ymax / 4) * 4,
        });

        add_download_csv(dest_div, we_stats.year + ' - ' + title, () => mustache((
            '\uFEFF' +
            '"WE"\t"Mit Impact Factor"\t"Ohne Impact Factor"\t"Summe"\r\n' +
            '{{#data}}' +
                '"{{we}}"\t"{{has_if}}"\t"{{no_if}}"\t"{{count}}"\r\n' +
            '{{/data}}'
        ), { data }));
    }

    we_stats = pubdb.we_stats;
    dest = $(dest || '#pubdb_data');

    const count_by_we = map(range(20), () => 0);
    const accu_if_by_we = map(count_by_we, () => 0);
    const has_if_by_we = map(count_by_we, () => 0);
    const quartiles_by_we = map(count_by_we, () => [0, 0, 0, 0, 0]);

    let has_unknown_quartiles = 0;
    const { length } = pubs;
    for (let i = 0; i < length; ++i) {
        let [we, ifactor, quartile] = pubs[i];
        if (!we || we > 20) {
            continue;
        }
        --we;
        ++count_by_we[we];
        if (ifactor && +ifactor > 0) {
            accu_if_by_we[we] += +ifactor;
            ++has_if_by_we[we];
            if (quartile && +quartile > 0) {
                ++quartiles_by_we[we][quartile - 1];
            } else {
                ++quartiles_by_we[we][4];
                ++has_unknown_quartiles;
            }
        }
    }

    dest.empty();
    add_totals_bar('Anzahl der wissenschaftlichen Beiträge');
    add_quartiles_bar('Davon mit Impact Factor');
    add_bar('Kumulativer Impact Factor', (i) => accu_if_by_we[i]);
    add_bar('Durchschnittlicher Impact Factor', (i) => !has_if_by_we[i] ? 0 : accu_if_by_we[i] / has_if_by_we[i]);
}


/*
function display_ref_groups (dest) {
    dest = $(dest || '#pubdb_data')
    if (!dest) {
        return;
    }
    dest.empty();
    
    const we_stats = pubdb.we_stats;

    let start_i = 0;
    for (let group_i = 0; group_i < we_stats.groups.length; ++group_i) {
        const group = we_stats.groups[group_i];

        let ymax = 0;
        let data = [];
        let avgavg = 0;
        for (let year_i = 0; year_i < we_stats.years.length; ++year_i) {
            let year = we_stats.years[year_i];
            let datum = {
                year: year.year,
                avgavg: 0,
                avg: 0,
            };
            let avg = 0;
            for (let inst_i = 0; inst_i < group.inst.length; ++inst_i) {
                const value  = +(year.pubs[inst_i + start_i] / year.vz[inst_i + start_i]).toFixed(2);
                datum[group.inst[inst_i]] = value;
                if (value > ymax) {
                    ymax = value;
                }
                avg += value;
            }
            datum.avg = +(avg / group.inst.length).toFixed(2);
            avgavg += avg;
            data.push(datum);
        }
        start_i += group.inst.length;

        avgavg = +(avgavg / (group.inst.length * we_stats.years.length)).toFixed(2);
        for (let data_i = 0; data_i < data.length; ++data_i) {
            data[data_i].avgavg = avgavg;
        }

        window.console.log(data);

        let ykeys = group.inst.slice();
        let labels = group.inst.slice();
        ykeys.splice(0, 0, 'avg');
        labels.splice(0, 0, 'ø Jahr');

        add_graph(dest, group.name, {
            data,
            // ymax: Math.ceil(ymax / 0.2) * 0.2,
            xkey: 'year',
            ykeys,
            labels,
            stacked: false,
            lineWidth: 1,
            grid: false,
            goals: [avgavg],
            _type: 'Line',
        });
    }
}
*/

function display_ref_groups (dest) {
    dest = $(dest || '#pubdb_data')
    if (!dest) {
        return;
    }
    dest.empty();
    
    const we_stats = pubdb.we_stats;
    [].forEach.call(we_stats.graphs, ({ title, resolution, data }) => {
        let ymax = Math.max.apply(
            null,
            data.map(year_data => Math.max.apply(
                null,
                we_stats.groups.map(group => year_data[group]),
            )),
        );
        const { dest_div, graph } = add_graph(dest, title, {
            ymax: Math.ceil(ymax / resolution) * resolution,
            data,
            xkey: 'year',
            ykeys: we_stats.groups,
            labels: we_stats.groups,
            stacked: false,
            _type: 'Line',
        });
        $("<div>", {
            css: { textAlign: "right" },
            append: we_stats.groups.map((group, i) => $("<span>", {
                text: ' ' + group + ' ',
                prepend: $("<span>", {
                    css: {
                        display: "inline-block",
                        width: "1ch",
                        height: "1ch",
                        marginLeft: "2em",
                        background: graph.options.lineColors[i],
                    },
                }),
            })),
            insertAfter: dest_div,
        });
    });
}


pubdb.display_we_stats = display_when_ready(display_we_stats);
pubdb.display_all_wes_stats = display_when_ready(display_all_wes_stats);
pubdb.display_ref_groups = display_when_ready(display_ref_groups);
